import React from "react";
import { UserComponent } from "../components/user/user";

export const Authentication = () => {
 
  return (
    <div>
      <UserComponent />
    </div>
  );
};
